class WishlistAPI {

    constructor() {
        this.base = "/apps/wishlist";
    }

    async request(url = "", options = {}) {

        const response = await fetch(this.base + url, {
            headers: {
                "Content-Type": "application/json",
                ...(options.headers || {})
            },
            ...options
        });

        if (!response.ok) {

            let message = "Wishlist request failed";

            try {
                const error = await response.json();
                message = error.error || message;
            } catch {}

            throw new Error(message);
        }

        return response.json();

    }

    async get() {

        return this.request(
            `?customerId=${encodeURIComponent(
                String(window.seekWishlistSettings.customerId)
            )}`
        );

    }

    async add(variantId) {

        return this.request("", {
            method: "POST",
            body: JSON.stringify({
                action: "add",
                customerId: String(window.seekWishlistSettings.customerId),
                variantId: String(variantId)
            })
        });

    }

    async remove(variantId) {

        return this.request("", {
            method: "POST",
            body: JSON.stringify({
                action: "remove",
                customerId: String(window.seekWishlistSettings.customerId),
                variantId: String(variantId)
            })
        });

    }

}

window.WishlistAPI = new WishlistAPI();